module.exports = "<a class=\"form-text\" href=\"javascript:void(0)\" (click)=\"sortList()\">\n  {{label}}\n  <i [ngClass]=\"isSorted && isAsc ? 'fas fa-caret-up' : 'fas fa-caret-down'\" class=\"\" *ngIf=\"isSorted\" ></i>\n</a>\n"


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/pagination-sort/pagination-sort.component.html
// module id = XRtp
// module chunks = 0